import { configure } from 'vee-validate'

configure({
  // Prevent validation when forms mount
  validateOnMount: false,

  // Enable validation on blur/input only
  validateOnBlur: true,
  validateOnInput: true,
  validateOnChange: false,

  // Optional: customize error messages globally
  generateMessage: (ctx) => {
    return `${ctx.field} is required`
  }
})
